import { InputFileUploadComponent } from './input-file-upload.component';
import ngFileUpload from 'ng-file-upload';

export default angular
  .module('sfMobile.components.input-file-upload', [
    'sfMobile.components.button-big',
    ngFileUpload,
  ])
  .component('sfInputFileUpload', InputFileUploadComponent).name;
